import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-delete-circle-red",
  "use": "icon-delete-circle-red-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 16\" id=\"icon-delete-circle-red\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.833 8a4.667 4.667 0 1 1 9.334 0 4.667 4.667 0 0 1-9.334 0ZM8.5 2a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm-2 5.333a.667.667 0 0 0 0 1.334h4a.667.667 0 1 0 0-1.334h-4Z\" fill=\"#CF1322\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol